<template>
  <PSSysVisit />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
